var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgBox"},[_c('div',{staticClass:"contBox"},[_c('el-header',[_c('hq-nav')],1),_c('el-main',[_c('hq-main')],1)],1),_c('el-footer',{staticClass:"footer"},[_c('hq-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }